import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Environment, Float } from '@react-three/drei';
import Book3D from './Book3D';
import FloatingParticles from './FloatingParticles';

interface HeroSceneProps {
  onBookClick?: () => void;
}

const HeroScene: React.FC<HeroSceneProps> = ({ onBookClick }) => {
  return (
    <Canvas
      camera={{ position: [0, 0, 6], fov: 50 }}
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
      gl={{ antialias: true, alpha: true }}
    >
      <color attach="background" args={['#0a0a0f']} />

      <ambientLight intensity={0.3} />
      <directionalLight position={[5, 5, 5]} intensity={0.8} color="#ffffff" />
      <directionalLight position={[-3, 3, -3]} intensity={0.3} color="#c9a84c" />
      <pointLight position={[0, -2, 3]} intensity={0.5} color="#e94560" />

      <Suspense fallback={null}>
        <Float speed={1.5} rotationIntensity={0.2} floatIntensity={0.5}>
          <Book3D
            title="Through the Fence"
            author="Ano Mkhulisi"
            position={[0, 0, 0]}
            rotation={[0.1, -0.3, 0]}
            scale={1.2}
            onClick={onBookClick}
          />
        </Float>

        {/* Additional decorative books */}
        <Float speed={1} rotationIntensity={0.1} floatIntensity={0.3}>
          <Book3D
            title=""
            author=""
            color="#e94560"
            position={[-3.5, -0.5, -2]}
            rotation={[0.2, 0.5, 0.1]}
            scale={0.6}
            hoverable={false}
          />
        </Float>

        <Float speed={1.2} rotationIntensity={0.15} floatIntensity={0.4}>
          <Book3D
            title=""
            author=""
            color="#4ecdc4"
            position={[3.2, 0.5, -1.5]}
            rotation={[-0.1, -0.6, -0.1]}
            scale={0.5}
            hoverable={false}
          />
        </Float>

        <FloatingParticles count={150} color="#c9a84c" spread={12} />
        <FloatingParticles count={50} color="#e94560" spread={10} />

        <Environment preset="night" />
      </Suspense>

      <OrbitControls
        enableZoom={false}
        enablePan={false}
        maxPolarAngle={Math.PI / 1.8}
        minPolarAngle={Math.PI / 3}
        autoRotate
        autoRotateSpeed={0.3}
      />
    </Canvas>
  );
};

export default HeroScene;
